import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Bootstrap
import { Modal, Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Tabs
import TabStaffsTrainingTab from './TabStaffsTrainingTab';
import TabTeamTrainingMatterStaffExamsTab from './TabTeamTrainingMatterStaffExamsTab';

class StaffsTrainingTab extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      'provas_avulsas': [],
      'treinamentos': [],
      'modal': false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.treinamentos)) {
      this.setState({treinamentos: newProps.treinamentos});
      this.setState({provas_avulsas: newProps.provas_avulsas});
    }
  }
  
  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id={'staff-tabs'}>
    <Tab eventKey={1} title="Treinamentos">
      <TabStaffsTrainingTab handleAlert={this.handleAlert} treinamentos={this.state.treinamentos} />
    </Tab>
    <Tab eventKey={2} title="Provas Avulsas">
      <TabTeamTrainingMatterStaffExamsTab handleAlert={this.handleAlert} provas_avulsas={this.state.provas_avulsas} />
    </Tab>
  </Tabs>  
</div>
    );
  }
}

export default StaffsTrainingTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsTrainingTab.js